export default function ({ store, params, navigator }) {
  return null
}
